<template>
	<div class="loadings.main">
		<el-form
			ref="editorForm"
			:model="info"
			status-icon
			label-position="left"
			label-width="120px"
			size="mini"
			v-loading="loadings.main"
			v-if="hasGetTableDataModel"
			@submit.native.prevent
			:rules="rules"
		>
			<div class="row">
				<div class="col-md-12" v-if="tableDataModel['primary_imgs']">
					<el-form-item :label="tableDataModel['primary_imgs'].show_name">
						<field-editor
							v-model="info['primary_imgs']"
							@change.native="handleFormEdited"
							@change="handleFormEdited"
							:field-info="tableDataModel['primary_imgs']"
							data-model="product_color"
							record-model="product_color"
							:record-id="recordId"
						></field-editor>
						<span class="text-muted text-small">建议尺寸 900*1200 或 750*1000</span>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<div slot="footer" class="dialog-footer" v-loading="loadings.formLoading">
			<el-button size="mini" type="primary" @click="doConfirmEdit()">确 定</el-button>
		</div>
	</div>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";

export default {
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false,
				colors: false
			},
			styles: [],
			everEdited: false,
			rules: {
				// intro: [
				// 	{
				// 		required: true,
				// 		message: "请输入",
				// 		trigger: "change"
				// 	}
				// ]
			},
			fields: [
				{
					name: "intro",
					col: 12
					// width: "100%"
				}
			],
			colors: []
		};
	},
	props: {
		dataModel: {
			type: String,
			default: ""
		},
		value: {
			type: Object,
			default: () => {
				return {};
			}
		},
		tableDataModel: {
			type: Object,
			default: () => {
				return {};
			}
		},
		recordId: {
			type: String,
			default: ""
		}
	},
	mounted() {},
	computed: {
		info: {
			// getter
			get: function() {
				return this.value;
			},
			// setter
			set: function(newValue) {
				// this.$emit("change", JSON.parse(JSON.stringify(this.info)));
			}
		},
		hasGetTableDataModel() {
			if (this.tableDataModel._id) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		handleFormEdited() {
			this.everEdited = true;
		},
		handleSelect() {},

		refreshColorsData() {
			this.loadings.colors = true;
			this.$axios
				.post(`/inventory/list_colors/${this.recordId}`, {})
				.then(json => {
					this.loadings.colors = false;
					this.colors = [];
					let colorMapping = {};
					for (let k = 0; k < json.data.datas.length; k++) {
						console.log(json.data.datas[k]);
						this.colors.push(json.data.datas[k]);
					}
				})
				.catch(json => {
					this.loadings.colors = false;
				});
		},

		doConfirmEdit() {
			if (!this.everEdited) {
				this.$message.warning("数据无变化");
				return;
			}
			this.$refs["editorForm"].validate(valid => {
				if (!valid) {
					return false;
				}
				this.loadings.formLoading = true;
				let post = {
					primary_imgs: this.info.primary_imgs,
					product_colors: this.colors
				};

				this.$axios
					.post(`/spu/do_edit_imgs/${this.recordId}`, post)
					.then(json => {
						this.loadings.formLoading = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$message.success("成功");
						this.$emit(
							"change",
							JSON.parse(JSON.stringify(this.info))
						);
						this.refreshColorsData();
					})
					.catch(json => {
						this.loadings.formLoading = false;
						this.$message.error(json.data.msg);
					});
			});
		}
	},
	components: {
		FieldEditor
	},
	watch: {
		recordId: {
			handler() {
				if (this.recordId == "") {
					return;
				}
				this.$nextTick(() => {
					this.refreshColorsData();
				});
			},
			immediate: true
		}
	}
};
</script>